import React from 'react';
import { SuspenseWrapper } from './SuspenseWrapper';
import LoginOnboardingRedirect from './redirects/LoginOnboardingRedirect';

function ProfilesRoute() {
  return (
    <SuspenseWrapper>
      <LoginOnboardingRedirect>
        <ProfileView />
      </LoginOnboardingRedirect>
    </SuspenseWrapper>
  );
}

const ProfileView = React.lazy(() => import('../ProfileView/ProfileView'));

export default ProfilesRoute;
